import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/layout/sidebar';
import { Header } from '@/components/layout/header';
import { useSettings } from '@/providers/settings-provider';

/**
 * Admin Layout Component
 * Main layout wrapper for the admin panel
 * Includes: Sidebar navigation, Header, Content area
 */
export function AdminLayout() {
  const { settings } = useSettings();

  useEffect(() => {
    const bodyClass = document.body.classList;

    // Add layout classes to body
    bodyClass.add('admin-layout');
    bodyClass.add('sidebar-fixed');
    bodyClass.add('header-fixed');

    const timer = setTimeout(() => {
      bodyClass.add('layout-initialized');
    }, 100);

    // Cleanup on unmount
    return () => {
      bodyClass.remove('admin-layout');
      bodyClass.remove('sidebar-fixed');
      bodyClass.remove('header-fixed');
      bodyClass.remove('layout-initialized');
      clearTimeout(timer);
    };
  }, []);

  // Apply sidebar collapse state to body
  useEffect(() => {
    const bodyClass = document.body.classList;
    
    if (settings.layouts.admin.sidebarCollapse) {
      bodyClass.add('sidebar-collapse');
    } else {
      bodyClass.remove('sidebar-collapse');
    }
  }, [settings.layouts.admin.sidebarCollapse]);

  return (
    <>
      <Sidebar />

      <div className="wrapper flex grow flex-col">
        <Header />

        {/* Page Content */}
        <main className="grow pt-5">
          <Outlet />
        </main>
      </div>
    </>
  );
}

